
import { Observable, Subject, Subscription, BehaviorSubject } from 'rxjs';
import { SignalRConnectionState } from '../../enum/realtime/signalr-connection-state.enum';
import { Injectable, OnDestroy } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as signalR from '@microsoft/signalr';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { UserManagerService } from '../../services/users/user-manager.service';
import { SubscribersInfo } from './realtime-common.service';
import { SettingsService } from '../settings/settings.service';
import { environment } from './../../../src/environments/environment';

@AutoUnsubscribe()
@Injectable()
export class RealtimeQuoteService implements OnDestroy{

    private quoteApiConnectionState: SignalRConnectionState = SignalRConnectionState.Disconnected;
    private quoteApiConnectionSubject$ = new BehaviorSubject<HubConnection>(null);
    private activeSubscriptions = new SubscribersInfo();

    public sessionIdSubscription: Subscription;
    public logoutAndLoginSubscription: Subscription;
    public userTokenSubscription: Subscription;
    public remakeSubscriptionsSubscription: Subscription;
    public authenticatedConnection: boolean;

    //quote
    private quoteApi: HubConnection;
    private quoteApiSubject = new Subject<any>();

    constructor(
        private UserManagerService: UserManagerService,
        private settingsService: SettingsService
    ) { }

    public quoteApiSubjectObs(): Observable<any> {
        return this.quoteApiSubject;
    }

    async connectToQuoteApi() {
        if (this.quoteApiConnectionState === SignalRConnectionState.Connecting)
            return;

        if (this.quoteApiConnectionState === SignalRConnectionState.Connected) {
            this.quoteApiConnectionSubject$.next(this.quoteApi);
            this.quoteApiConnectionSubject$.complete();
        }
        let url = this.settingsService.getConfigurationKeyValue('rqapi');
        let token = this.UserManagerService.getUserRealtimeToken();

        this.quoteApiConnectionState = SignalRConnectionState.Connecting;
            this.quoteApi = new HubConnectionBuilder()
                .withUrl(url, {
                    skipNegotiation: true,
                    transport: signalR.HttpTransportType.WebSockets,
                    accessTokenFactory: () => token 
                })
                .withAutomaticReconnect()
                .build();
    
            this.quoteApi
            .start()
            .then(() => { 
                this.quoteApi.invoke('SubscribeQuote', this.activeSubscriptions.topics);

                this.quoteApi.onclose(() => {
                    this.quoteApiConnectionSubject$ = new BehaviorSubject<HubConnection>(null);
                    this.quoteApiConnectionState = SignalRConnectionState.Disconnected;
                })

                this.quoteApi.on('ReceiveQuote', (data: any) => {
                    if (data)
                        this.quoteApiSubject.next(data);
                });            

                this.quoteApiConnectionState = SignalRConnectionState.Connected;
                this.quoteApiConnectionSubject$.next(this.quoteApi);
                this.quoteApiConnectionSubject$.complete();
            })                
            .catch(() => {
                this.quoteApiConnectionState = SignalRConnectionState.Disconnected;
                this.connectToQuoteApi();
            });
    }

    /** Realiza inscricão para recebimento de cotação de um ativo
     * @param symbol código do ativo
     * @return Observable que notifica sobre novas cotações recebidas
     */
    subscribeActiveQuote(symbol: string) {
        if (this.quoteApiConnectionState === SignalRConnectionState.Connected) {
            this.quoteApi.invoke('SubscribeQuote', [symbol]).then(() => {
                this.activeSubscriptions.registerSubscriber(symbol)
            })
        } 
        else {
            this.quoteApiConnectionSubject$.subscribe((connection) => {
                if (this.quoteApiConnectionState === SignalRConnectionState.Connected) {                    
                    connection.invoke('SubscribeQuote', [symbol]).then(() => {
                        this.activeSubscriptions.registerSubscriber(symbol)
                    })
                }
            })
            this.connectToQuoteApi();
        }
    }

    /** Realiza inscrição de uma lista de ativos para receber cotações
     * @param symbols códigos dos ativos a serem assinados
     * @return Stream que notifica sobre atualização da cotação
     */
    subscribeActivesArrayQuote(symbols: Array<string>) {
        if (this.quoteApiConnectionState === SignalRConnectionState.Connected) 
            this.quoteApi.invoke('SubscribeQuote', symbols).then(() => {
                this.activeSubscriptions.registerSubscribers(symbols)
            })
        else {
            this.quoteApiConnectionSubject$.subscribe((connection) => {
                if (this.quoteApiConnectionState === SignalRConnectionState.Connected)
                    connection.invoke('SubscribeQuote', symbols).then(() => {
                        this.activeSubscriptions.registerSubscribers(symbols)
                    })
            })
            this.connectToQuoteApi();
        }
    }

    /** Realiza unsubscribe para cotação de um ativo
     * @param symbol ativo que não é mais necessária a cotação
     */
    unsubscribeActiveQuote(symbol: string) {
        if (this.quoteApiConnectionState === SignalRConnectionState.Connected) 
            this.quoteApi.invoke('UnsubscribeQuote', [symbol]).then(() => {
                this.activeSubscriptions.removeOneSubscriber(symbol)
            });
    }

    /** Realiza unsubscribe para cotação de ativos
     * @param symbols ativos que não são mais necessário o recebimento de cotação
     */
    unsubscribeActiveArrayQuote(symbols: Array<string>) {
        if (this.quoteApiConnectionState === SignalRConnectionState.Connected) 
            this.quoteApi.invoke('UnsubscribeQuote', symbols).then(() => {
                symbols.forEach((symbol) => {
                    this.activeSubscriptions.removeOneSubscriber(symbol)
                })
            })
    }

    ngOnDestroy() {

    }
}
